import "./style.scss";

import VueSlickCarousel from "vue-slick-carousel";

var app = new Vue({
  el: "#js-access",
  components: {
    VueSlickCarousel,
  },
  data() {
    return {
      settings: {
        arrows: false,
        dots: true,
        swipeToSlide: true,
        centerMode: true,
        centerPadding: "10px",
        slidesToShow: 3,
        responsive: [
          {
            breakpoint: 720,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      },
    };
  },
});
